import { capitalize } from 'lodash';

const getFieldLabel = field => {
  return capitalize(field);
};

export default getFieldLabel;
